export const DEFAULT_FIELDS_TO_SUBMIT: string[] = [
  "pan",
  "expirydate",
  "securitycode",
];
